module.exports = __webpack_public_path__ + "static/media/2.4135aa26.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/2.png
// module id = 979
// module chunks = 0